import { Button } from 'antd';
import { useKanagawaMode, useKanagawaPalette } from '@aid/theme';
import { useAuth } from './providers/KeycloakProvider';

export function LoginPage() {
  const palette = useKanagawaPalette();
  const mode = useKanagawaMode();
  const { login } = useAuth();

  // Button text is mode-aware to keep AA contrast on the accent fill:
  // dark text on Dragon blue (#1F1F28 on #7E9CD8 ≈ 6.0:1), light text on
  // Lotus blue (#FFFFFF on #4D699B ≈ 5.5:1).
  const buttonTextColor = mode === 'dark' ? '#1F1F28' : '#FFFFFF';

  return (
    <div
      style={{
        minHeight: '100dvh',
        background: palette.base,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 400,
          background: palette.mantle,
          border: `1px solid ${palette.surface1}`,
          borderRadius: 16,
          padding: 48,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 16,
          textAlign: 'center',
        }}
      >
        <h1
          style={{
            margin: 0,
            fontSize: 32,
            fontWeight: 600,
            letterSpacing: '-0.02em',
            color: palette.text,
          }}
        >
          Hub de aplicaciones
        </h1>
        <p
          style={{
            margin: 0,
            fontFamily: 'monospace',
            fontSize: 12,
            color: palette.subtext0,
          }}
        >
          Launch applications with a single click
        </p>
        <Button
          type="primary"
          size="large"
          block
          style={{
            background: palette.blue,
            color: buttonTextColor,
            fontWeight: 600,
            marginTop: 8,
          }}
          onClick={login}
        >
          Login with Keycloak
        </Button>
      </div>
    </div>
  );
}
